import Records from '@/views/records/Records'
import RecordsGrid from '@/views/records/RecordsGrid'
import RecordsGuarant from '@/views/records/RecordsGuarant'
import RecordsJustif from '@/views/records/RecordsJustif'
import RecordsMessages from '@/views/records/RecordsMessages'
import RecordsResa from '@/views/records/RecordsResa'
import RecordsTenant from '@/views/records/RecordsTenant'

export default [
  {
    name: 'records',
    path: '/dossiers/',
    component: Records,
    meta: {
      requiredAuth: true
    },
    children: [
      {
        name: 'records-grid',
        path: '',
        component: RecordsGrid
      },
      {
        name: 'records-justif',
        path: ':id/pieces-justificatives/:person_id',
        component: RecordsJustif
      },
      {
        name: 'records-messages',
        path: ':id/messages',
        component: RecordsMessages
      },
      {
        name: 'records-resa',
        path: ':id/reservation',
        component: RecordsResa
      },
      {
        name: 'records-guarant',
        path: ':id/ajout-de-garant',
        component: RecordsGuarant
      },
      {
        name: 'records-guarant-update',
        path: ':id/modification-de-garant/:guarantor_id',
        component: RecordsGuarant
      },
      {
        name: 'records-tenant',
        path: ':id/ajout-de-locataire',
        component: RecordsTenant
      },
      {
        name: 'records-tenant-update',
        path: ':id/modification-de-locataire/:tenant_id',
        component: RecordsTenant
      }
    ]
  }
]
